// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3yKoG","container":"styles_container__3aus4","title":"styles_title__IomXP","wrapper":"styles_wrapper__1k5IQ","answer":"styles_answer__3P2iu"};